import React from "react";
import { Link } from "react-router-dom";

export default function CTABanner({
    eyebrow = "Limited Seats Available",
    title = "Begin your musical journey today.",
    subtitle = "Book a free one-on-one demo class with a certified instructor — zero commitment, maximum clarity.",
}) {
    return (
        <section data-testid="cta-banner" className="relative bg-black overflow-hidden">
            <div className="absolute inset-0 bg-radial-gold opacity-80" aria-hidden />
            <div className="absolute inset-0 bg-grid opacity-40" aria-hidden />

            <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28">
                <div className="rounded-[28px] border border-gold/30 bg-gradient-to-br from-[#1a1405] via-[#0f0c04] to-[#0a0a0a] p-8 md:p-14 text-center">
                    <span className="inline-block text-[10px] tracking-[0.3em] uppercase text-gold mb-5 border border-gold/30 rounded-full px-4 py-1.5">
                        {eyebrow}
                    </span>
                    <h2 className="font-display font-bold text-3xl md:text-5xl text-white text-balance max-w-3xl mx-auto leading-tight">
                        {title}
                    </h2>
                    <p className="text-white/60 text-base md:text-lg mt-5 max-w-2xl mx-auto">
                        {subtitle}
                    </p>
                    <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
                        <Link
                            to="/contact"
                            data-testid="cta-book-demo-btn"
                            className="inline-flex items-center justify-center bg-gold text-black font-semibold text-sm px-8 py-4 rounded-full hover:scale-[1.03] hover:bg-gold-hover transition-all duration-300 gold-glow-strong"
                        >
                            Book Free Trial Class
                        </Link>
                        <a
                            href="tel:+918800747721"
                            data-testid="cta-call-btn"
                            className="inline-flex items-center justify-center border border-white/20 text-white font-semibold text-sm px-8 py-4 rounded-full hover:bg-white/5 transition-colors"
                        >
                            Call +91 88007 47721
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
